import React, { useState } from 'react';

const safeDecodeURIComponent = (value = '') => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const AttachmentLink = (props) => {
  const [fetching, setFetching] = useState(false);
  const { url, filename, includeDeleteButton, deleteFunction } = props;
  const name = url.split('/');
  const nameToShow = filename ?? safeDecodeURIComponent(name[name.length - 1]);

  const handleRowClick = () => {
    downloadFile();
  };

  const downloadFile = () => {
    setFetching(true);
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to download attachment. Status: ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        setFetching(false);
        const blobURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobURL;
        a.style = 'display: none';

        if (nameToShow && nameToShow.length) a.download = nameToShow;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => {
          URL.revokeObjectURL(blobURL);
        }, 0);
      })
      .catch((error) => {
        // Avoid downloading HTML error pages when the attachment request fails.
        console.error(error);
        setFetching(false);
      });
  };

  return (
    <>
      <li className='attachment-box' onClick={handleRowClick}>
        <button
          type='button'
          disabled={fetching}
          className={`general-button `}
          data-tooltip-id={'general-tooltip'}
          data-tooltip-content={'Download'}
          onClick={(e) => {
            e.stopPropagation();
            downloadFile();
          }}
        >
          {fetching ? (
            <i className='fas fa-spinner fa-spin ml-3'></i>
          ) : (
            <span className='icon-arrow-download ml-3 main-subtle-text'></span>
          )}
        </button>
        <span className='attachment-file-name flex-grow-1'>{nameToShow}</span>
        {includeDeleteButton && (
          <button
            type='button'
            className='general-button topic-alert-delete mr-3'
            data-tooltip-id={'general-tooltip'}
            data-tooltip-content={'Delete'}
            onClick={(e) => {
              e.stopPropagation();
              deleteFunction(e);
            }}
          ></button>
        )}
      </li>
    </>
  );
};

export default AttachmentLink;
